import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './lib/i18n';
import { BrowserRouter } from 'react-router-dom';

const domNode = document.getElementById('root') as HTMLElement;
const root = createRoot(domNode);

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
